export const PLACE_WITH_CARDS_ERROR =
  'transportcardplaceservice.removetransportcardplace.cards';
